import React from 'react';
import './App.css';

import HexColorClock from './components/HexClock'

function App() {
  return (
    <div className="App">
      <HexColorClock/>
    </div>
  );
}

export default App;
